import { MutationOptions, useMutation } from "react-query";
import { APIError, APIResponse, post } from "../api";
import { API_URL_V1 } from "../api";

function useVerifyBVN<T>(
  options?: MutationOptions<APIResponse<T>, APIError, Record<any, any>>
) {
  const {
    isLoading: verifyingBVN,
    isError: isVerifyingBVNError,
    error: verifyingBVNError,
    mutate: verifyBvn,
  } = useMutation(async (variables: Record<any, any>) => {
    const raw = variables.bvn ?? variables.bvn_number;
    const bvn =
      raw === undefined || raw === null ? "" : String(raw).replace(/\D/g, "");
    const res = await post(
      API_URL_V1 + "/kyc/bvn/basic",
      {
        bvn,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    ) as APIResponse<any>;

    return {
      ...res,
      data: res.data?.entity || res.data,
    };
  }, options);

  return {
    verifyBvn,
    isVerifyingBVNError,
    verifyingBVNError,
    verifyingBVN,
  };
}

export default useVerifyBVN;
